import Alert from './components/Alert';

export default Alert;
